import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { Button } from "../../components/button.component";
import { useCountdown } from "../../hooks";
import { IApiSchemaSyncActivation } from "../../models/api";
import { ApiDataExchange } from "../../core/apis/dataExchange";
import { SpinLoader } from "../../components/spinLoader.component";
import { StorageAuth } from "../../core/localStorage";

interface IProps {
  setHasToken: Dispatch<SetStateAction<boolean>>;
}

export function ActivateSync({ setHasToken }: IProps) {
  const { setDuration, formattedTime, timeLeft, getRemainingTime } =
    useCountdown();
  const [isPending, setIsPending] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const initialLoadRef = useRef(true);
  const companyId = StorageAuth.CompanyId || "";

  const handleActivation = async () => {
    if (!companyId) {
      alert("No company selected. Please select a company first.");
      return;
    }

    await ApiDataExchange.GetNewToken({
      companyId,
      onStart: () => setIsPending(true),
      onEnd: () => setIsPending(false),
      onSuccess: (data: IApiSchemaSyncActivation) => {
        const { createdAt } = data;
        setHasToken(true);
        setDuration({ createdAt, expireIn: 1800000 });
      },
    });
  };

  useEffect(() => {
    if (!initialLoadRef.current) {
      return;
    }
    initialLoadRef.current = false;
    const getExistingToken = async () => {
      await ApiDataExchange.GetExistingToken({
        companyId,
        onStart: () => setIsChecking(true),
        onEnd: () => setIsChecking(false),
        onSuccess: (data: IApiSchemaSyncActivation) => {
          if (!data) {
            return;
          }
          const { createdAt } = data;
          if (createdAt) {
            const remainingTime = getRemainingTime(createdAt, 1800000);
            if (remainingTime > 0) {
              setHasToken(true);
            }
            setDuration({ createdAt, expireIn: 1800000 });
          }
        },
      });
    };

    getExistingToken();
  }, [setDuration, getRemainingTime, setHasToken, companyId]);

  return isChecking ? (
    <SpinLoader />
  ) : (
    <div className="d-flex align-items-center">
      {!!timeLeft ? (
        <p>Token will be expired in : {formattedTime} </p>
      ) : (
        <Button
          name="Activate Sync"
          className="ms-1 btn-green"
          onClick={handleActivation}
          loading={isPending}
        />
      )}
    </div>
  );
}
